import React, { useEffect, useState } from "react";
import "./Header.css";
import { FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Header = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const brandName = webinfo.name || "Your Brand";
  const phoneText = webinfo.phone || "+91 80000 00000";
  const phoneHref = webinfo.phonecall
    ? `tel:${webinfo.phonecall}`
    : phoneText
    ? `tel:${phoneText}`
    : "tel:+918000000000";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 8);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleCall = () => {
    window.location.href = phoneHref;
  };

  return (
    <header className={`header2 ${scrolled ? "header2--scrolled" : ""}`}>
      <div className="header2-inner">
        {/* Logo / brand */}
        <button
          className="header2-logo"
          onClick={() => handleNavigate("/")}
          aria-label={`${brandName} home`}
        >
          <span className="header2-logo-mark" />
          <span className="header2-logo-text-group">
            <span className="header2-logo-text-main">{brandName}</span>
          
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="header2-nav" aria-label="Main navigation">
          <button
            className="header2-nav-item"
            onClick={() => handleNavigate("/")}
          >
            Home
          </button>
          <button
            className="header2-nav-item"
            onClick={() => handleNavigate("/services")}
          >
            Services
          </button>
          <button
            className="header2-nav-item"
            onClick={() => handleNavigate("/our-strategies")}
          >
            Strategies
          </button>
          <button
            className="header2-nav-item"
            onClick={() => handleNavigate("/about")}
          >
            About
          </button>
          <button
            className="header2-nav-item"
            onClick={() => handleNavigate("/process")}
          >
            Process
          </button>
          <button
            className="header2-nav-item"
            onClick={() => handleNavigate("/contact")}
          >
            Contact
          </button>
        </nav>

        {/* Desktop actions */}
        <div className="header2-actions">
          <button className="header2-call" onClick={handleCall}>
            <FaPhoneAlt className="header2-call-icon" />
            <span className="header2-call-label">{phoneText}</span>
          </button>
          <button
            className="header2-cta"
            onClick={() => handleNavigate("/services")}
          >
            Book a strategy call
          </button>
        </div>

        {/* Hamburger (mobile) */}
        <button
          className="header2-burger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`header2-mobile ${menuOpen ? "is-open" : ""}`}>
        <div className="header2-mobile-panel">
          <nav className="header2-mobile-nav" aria-label="Mobile navigation">
            <button
              className="header2-mobile-item"
              onClick={() => handleNavigate("/")}
            >
              Home
            </button>
            <button
              className="header2-mobile-item"
              onClick={() => handleNavigate("/services")}
            >
              Services
            </button>
            <button
              className="header2-mobile-item"
              onClick={() => handleNavigate("/our-strategies")}
            >
              Strategies
            </button>
            <button
              className="header2-mobile-item"
              onClick={() => handleNavigate("/about")}
            >
              About
            </button>
            <button
              className="header2-mobile-item"
              onClick={() => handleNavigate("/process")}
            >
              Process
            </button>
            <button
              className="header2-mobile-item"
              onClick={() => handleNavigate("/contact")}
            >
              Contact
            </button>
          </nav>

          <div className="header2-mobile-actions">
            <button className="header2-call header2-call--full" onClick={handleCall}>
              <FaPhoneAlt className="header2-call-icon" />
              <span className="header2-call-label">{phoneText}</span>
            </button>
            <button
              className="header2-cta header2-cta--full"
              onClick={() => handleNavigate("/services")}
            >
              Book a strategy call
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
